import axios, { AxiosError, AxiosInstance } from 'axios';
import { triggerSnackbar } from '../provider/SnackbarProvider';
import { API_BASE_URL } from '../constants/apiEndpoints';

const BASE_URL = API_BASE_URL;
const DEFAULT_API_VERSION = import.meta.env.VITE_DEFAULT_API_VERSION;

const subdomain = window.location.host.split('.')[0];
const isStagingOrUAT = ['eyeopstagingpatient', 'eyeopuatpatient'].includes(
  subdomain
);

const SUB_DOMAIN_HEADER = isStagingOrUAT
  ? import.meta.env.VITE_SUB_DOMAIN_DEV
  : import.meta.env.VITE_SUB_DOMAIN;
const VENDOR_MEDIA_TYPE = import.meta.env.VITE_VENDER_MEDIA_TYPE;

function createAcceptHeader(version: number = DEFAULT_API_VERSION): string {
  return `application/${VENDOR_MEDIA_TYPE}; version=${version}`;
}

const apiClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: createAcceptHeader(),
    'Sub-Domain': SUB_DOMAIN_HEADER,
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = JSON.parse(
      localStorage.getItem('AUTH_USER_DATA') || '{}'
    )?.accessToken;

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    triggerSnackbar({
      message: 'Something went wrong',
      severity: 'error',
    });
    return Promise.reject(error);
  }
);

// Response Interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    const status = error.response?.status;
    if (status === 403) {
      localStorage.removeItem('AUTH_USER_DATA');
      window.location.reload();
      triggerSnackbar({
        message: 'Forbidden! You do not have access.',
        severity: 'error',
      });
    } else if (status === 401) {
      localStorage.removeItem('AUTH_USER_DATA');
      window.location.reload();
    } else if (status === 500) {
      triggerSnackbar({
        message: 'Server error! Please try again later.',
        severity: 'error',
      });
    }
    return Promise.reject(error);
  }
);

export default apiClient;
